import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import ButtonTabs from '../../../../core/modules/common/components/ButtonTabs';
import AdminReportSettingModal from '../../../report/common/components/AdminReportSettingModal';
import {
  fetchAdminReportDefinitionsRequestActionCreator,
  fetchAdminReportCategoryRequestActionCreator,
  deleteCategoryAdminRequestActionCreator,
  editCategoryAdminSuccessActionCreator, saveCategoryAdminSuccessActionCreator,
} from '../redux/actions/AdminDashboardActions';
import AdminDashboardTabTypes from '../redux/actions/types/AdminDashboardTabTypes';
import {
  getAdminReports,
  getAdminReportCategory,
} from '../redux/selectors/AdminDashboardSelectors';
import Button from '../../../../core/modules/common/components/Button';
import AdminCategorySaveSettingModal from '../../../report/common/components/AdminCategorySaveSettingModal';
import AdminCategoryEditSettingModal from '../../../report/common/components/AdminCategoryEditSettingModal';
import DeleteModal from '../../../common/components/DeleteModal';
import { compareReportCategoriesForReportMenu, compareReportCategoriesForGroup, isMainReportCategory } from "../../../react-table/helpers/utils";

const tabs = [
  {
    value: AdminDashboardTabTypes.REPORTS,
    label: 'Reports',
  },
  {
    value: AdminDashboardTabTypes.CATEGORIES_TAGS,
    label: 'Categories/Tags',
  },
];

const tabsCategoriesTags = [
  {
    value: AdminDashboardTabTypes.CATEGORY,
    label: 'CATEGORY',
  },
  {
    value: AdminDashboardTabTypes.TAGGROUP1,
    label: 'TAG GROUP 1',
  },
  {
    value: AdminDashboardTabTypes.TAGGROUP2,
    label: 'TAG GROUP 2',
  },
  {
    value: AdminDashboardTabTypes.TAGGROUP3,
    label: 'TAG GROUP 3',
  },
  {
    value: AdminDashboardTabTypes.TAGGROUP4,
    label: 'TAG GROUP 4',
  },
];
export class AdminReportCategoriesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOnModifyReportModal: false,
      showOnModifyCategoryModal: false,
      // eslint-disable-next-line react/no-unused-state
      showOnModifyCategoryModalEdit: false,
      showOnDeleteModal: false,
      activeTab: 'REPORTS',
      activeTabCategory: 'CATEGORY',
      currentReport: {},
      selectedCategory: false,
      active: null,
      currentCategory: {},
    };
  }

  componentDidMount() {
    this.props.fetchAdminReportDefinitionsRequestActionCreator();
    this.props.fetchAdminReportCategoryRequestActionCreator();
  }

  navigateTab = activeTab => this.setState({
    activeTab,
  });

  isReportsTabActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.REPORTS;

  isCategoryTagTabActive = () =>
    this.state.activeTab === AdminDashboardTabTypes.CATEGORIES_TAGS;

  navigateTabForCategory = activeTabCategory => this.setState({
    activeTabCategory,
    active: null,
  });

  selectedRow = (report) => {
    this.setState({
      showOnModifyReportModal: true,
      currentReport: report,
    });
  };

  selectedCategoryRow = (category, item) => {
    this.setState({
      active: item,
      currentCategory: category,
      selectedCategory: true,
    });
  };

  cancel = () => {
    this.setState({
      active: null,
      selectedCategory: false,
    });
  };

  closeModal = () => {
    this.setState({
      showOnModifyReportModal: false,
    });
  };

  openCategorySaveModal = () => {
    this.setState({
      showOnModifyCategoryModal: true,
    });
  };

  closeCategorySaveModal = () => {
    this.setState({
      showOnModifyCategoryModal: false,
    });
  };

  openRemoveModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnDeleteModal: !!this.state.selectedCategory,
    });
  };

  closeRemoveModal = () => {
    this.setState({
      showOnDeleteModal: false,
    });
  };

  openCategoryModalByEdit = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnModifyCategoryModalByEdit: !!this.state.selectedCategory,
    });
  };

  closeCategoryEditModal = () => {
    this.setState({
      showOnModifyCategoryModalByEdit: false,
    });
  };

  deleteCategory = () => {
    const { name } = this.state.currentCategory;
    this.props.deleteCategoryAdminRequestActionCreator(name);
    this.closeRemoveModal();
  };

  render() {
    const {
      activeTabCategory,
      currentReport,
      active,
      currentCategory,
    } = this.state;

    let categoryTabData;
    const categoryResult = [];
    const categoryList = [];
    const categoryData = this.props.reportCategory;
    if (this.props.reportCategory !== undefined) {
      categoryTabData = this.props.reportCategory.filter(a => a.groupName === activeTabCategory);
      const catGroup = this.props.reportCategory.map(a => a.categoryGroup);
      let uniqueId;
      let categoryName;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < catGroup.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        categoryName = catGroup[i].categoryName;
        if (uniqueId !== catGroup[i].groupId) {
          uniqueId = catGroup[i].groupId;
          categoryResult.push({ value: uniqueId, label: categoryName });
        }
      }
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < categoryData.length; i++) {
        categoryList.push({
          value: categoryData[i].categoryId,
          label: categoryData[i].name,
        });
      }
    }
    if (activeTabCategory === 'CATEGORY') {
      categoryTabData = this.props.reportCategory;
    } else {
      // eslint-disable-next-line no-unused-expressions
      categoryTabData;
    }
    return (
      <div>
        <div className="admin-button-main-tabs">
          <ButtonTabs
            tabs={tabs}
            activeTab={this.state.activeTab}
            onChange={this.navigateTab}
          />
        </div>
        {this.isReportsTabActive() &&
        <div>
          <table className="admin-reports-table">
            <thead>
              <tr>
                <th>Report No</th>
                <th>Report Name</th>
                <th>Category</th>
                <th>Tags</th>
              </tr>
            </thead>
            {this.props.adminReports && this.props.adminReports.map((report, index) => (
              <tbody>
                {/* eslint-disable-next-line react/no-array-index-key */}
                <tr key={index} onClick={() => this.selectedRow(report)}>
                  <td>{report.reportNo}</td>
                  <td>{report.reportName}</td>
                  <td>{report.reportCategory.name}</td>
                  <td>{report.reportTags.map(tag => (
                    <div className="report-list-tagname-div">{tag.name}</div>
                ))}
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
        }
        {
          this.isCategoryTagTabActive() && (
            <div className="admin-button-second-tabs">
              <ButtonTabs
                tabs={tabsCategoriesTags}
                activeTab={this.state.activeTabCategory}
                onChange={this.navigateTabForCategory}
              />
              {
                activeTabCategory === 'CATEGORY' &&
                <table className="admin-reports-table-category" cellSpacing="0" cellPadding="0">
                  <thead>
                    <tr>
                      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                      <th />
                      <th>Name</th>
                      <th>Group Name</th>
                      <th>Group Sequence</th>
                      <th>Report Menu Sequence</th>
                      <th>Has Reports</th>
                      <th>Main Category</th>
                    </tr>
                  </thead>
                  {
                    [...categoryTabData]
                      .sort((a, b) => compareReportCategoriesForReportMenu(a, b))
                      .map((category, item) => (
                        <tbody>
                          <tr className={`tr-${active === item ? 'true' : 'false'}`} onClick={() => this.selectedCategoryRow(category, item)}>
                            <td className="right">{item + 1}</td>
                            <td>{category.name}</td>
                            <td>{category.groupName}</td>
                            <td>{category.displaySequence}</td>
                            <td>{category.displaySeqReportMenu}</td>
                            <td>{category.hasReports ? 'Y' : 'N'}</td>
                            <td>{isMainReportCategory(this.props.adminReports, category) ? 'Y' : 'N'}</td>
                          </tr>
                        </tbody>
                        ))
                  }
                </table>
              }
              { activeTabCategory !== 'CATEGORY' &&
              <table className="admin-reports-table-category" cellSpacing="0" cellPadding="0">
                <thead>
                  <tr>
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <th />
                    <th>Name</th>
                    <th>Group Sequence</th>
                    <th>Has Reports</th>
                  </tr>
                </thead>
                  {
                    [...categoryTabData]
                      .sort((a, b) => compareReportCategoriesForGroup(a, b))
                      .map((category, item) => (
                        <tbody>
                          <tr className={`tr-${active === item ? 'true' : 'false'}`} onClick={() => this.selectedCategoryRow(category, item)}>
                            <td>{item + 1}</td>
                            <td>{category.name}</td>
                            <td>{category.displaySequence}</td>
                            <td>{category.hasReports ? 'Y' : 'N'}</td>
                          </tr>
                        </tbody>
                        ))
                  }
              </table>
              }

              <div className="button-groups">
                <Button text="app.button.cancel" onClick={this.cancel} />
                <Button style={{ marginLeft: '10px' }} text="app.button.edit" onClick={this.openCategoryModalByEdit} />
                <Button style={{ marginLeft: '10px' }} text="app.button.remove" onClick={this.openRemoveModal} />
                <Button style={{ marginLeft: '10px' }} text="app.button.add" onClick={this.openCategorySaveModal} />
              </div>
            </div>
          )
        }
        {this.state.showOnModifyReportModal &&
          <AdminReportSettingModal onCloseModal={this.closeModal} currentReport={currentReport} categoryGroup={categoryList}>
            closeOnOutsideClick
          </AdminReportSettingModal>
        }
        {this.state.showOnModifyCategoryModal &&
          <AdminCategorySaveSettingModal onCloseModal={this.closeCategorySaveModal} categoryGroup={categoryResult}>
            closeOnOutsideClick
          </AdminCategorySaveSettingModal>
        }
        {this.state.showOnModifyCategoryModalByEdit &&
        <AdminCategoryEditSettingModal onCloseModal={this.closeCategoryEditModal} category={currentCategory} categoryGroup={categoryResult}>
          closeOnOutsideClick
        </AdminCategoryEditSettingModal>
        }
        {this.state.showOnDeleteModal &&
        <DeleteModal
          headerFormattedMessageId="app.warning.delete.category.admin"
          onCloseModal={this.closeRemoveModal}
          deleteSelection={this.deleteCategory}
        />
        }
      </div>
    );
  }
}

AdminReportCategoriesContainer.propTypes = {
  fetchAdminReportDefinitionsRequestActionCreator: PropTypes.func,
  fetchAdminReportCategoryRequestActionCreator: PropTypes.func,
  deleteCategoryAdminRequestActionCreator: PropTypes.func,
  adminReports: PropTypes.arrayOf(PropTypes.object),
  reportCategory: PropTypes.arrayOf(PropTypes.object),
};

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchAdminReportDefinitionsRequestActionCreator,
  fetchAdminReportCategoryRequestActionCreator,
  deleteCategoryAdminRequestActionCreator,
  saveCategoryAdminSuccessActionCreator,
  editCategoryAdminSuccessActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  adminReports: getAdminReports(state),
  reportCategory: getAdminReportCategory(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminReportCategoriesContainer);

